var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { formatTaxIdForDisplay, resolveCountryAndState, resolveEntityTypeCode, toContactOptions, toFormDate, } from './customer_lookup_service';
import { CUSTOMER_FIELD, GUARANTOR_ADDRESS_PREFIX, GUARANTOR_ASPIRE_FIELD, GUARANTOR_FIELD, GUARANTOR_HOME_ADDRESS_PREFIX, GUARANTOR_TYPE, SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD, } from './config/create_application_schema';
import { buildAddressFieldName, CANADA_COUNTRY_CODE, formatPercentageInput, formatPhoneInput, } from './config/form_field_factories';
import { formatSINInput, formatSSNInput } from '../../utils/customerPortalValidations';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
var ACCOUNT_TYPE_BUSINESS = 'B';
var ACCOUNT_TYPE_INDIVIDUAL = 'I';
var ENTITY_TYPE_GUARANTOR = 'GUARANTOR';
var toRawTaxId = function (value) {
    return asText(value).replace(/[^0-9A-Za-z]/g, '');
};
var hasAnyValue = function (record) {
    return Boolean(record) &&
        Object.values(record).some(function (value) { return value !== null && value !== undefined && String(value).trim() !== ''; });
};
var fetchGuarantorByTaxId = function (taxId, guarantorType) { return __awaiter(void 0, void 0, void 0, function () {
    var rawTaxId, response, matched, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                rawTaxId = toRawTaxId(taxId);
                if (!rawTaxId) {
                    return [2, null];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.GET_DETAILS_BY_FED_TAX_ID,
                        payLoad: {
                            SSN: rawTaxId,
                            AccType: guarantorType === GUARANTOR_TYPE.Business
                                ? ACCOUNT_TYPE_BUSINESS
                                : ACCOUNT_TYPE_INDIVIDUAL,
                            EntityType: ENTITY_TYPE_GUARANTOR,
                        },
                        showLoader: true,
                    })];
            case 2:
                response = _c.sent();
                if (Number((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, null];
                }
                matched = (_b = response.data.data) !== null && _b !== void 0 ? _b : {};
                return [2, hasAnyValue(matched.GuarantorInfo) ? matched : null];
            case 3:
                error_1 = _c.sent();
                return [2, null];
            case 4: return [2];
        }
    });
}); };
var addressField = function (suffix) {
    return buildAddressFieldName(GUARANTOR_HOME_ADDRESS_PREFIX, suffix);
};
var readPercentOwnership = function (guarantor) {
    var _a;
    var percent = asText((_a = guarantor.PercentOwnership) !== null && _a !== void 0 ? _a : guarantor.OwnershipPercentage);
    return percent ? formatPercentageInput(percent) : '';
};
var buildSharedGuarantorValues = function (guarantor, countryCode, stateCode) {
    var _a;
    return (_a = {},
        _a[addressField('Address')] = asText(guarantor.Address),
        _a[addressField('Country')] = countryCode,
        _a[addressField('City')] = asText(guarantor.City),
        _a[addressField('State')] = stateCode,
        _a[addressField('PostalCode')] = asText(guarantor.PostalCode),
        _a[addressField('Email')] = asText(guarantor.Email),
        _a[addressField('Phone')] = formatPhoneInput(asText(guarantor.PhoneNumber)),
        _a[GUARANTOR_ASPIRE_FIELD.GuarantorAspireOId] = asText(guarantor.GuarantorAspireOId),
        _a[GUARANTOR_ASPIRE_FIELD.GuarantorAspireRecordId] = asText(guarantor.GuarantorAspireRecordId),
        _a[GUARANTOR_ASPIRE_FIELD.LocationAspireOId] = asText(guarantor.LocationAspireOId),
        _a[GUARANTOR_ASPIRE_FIELD.LocationAspireRecordId] = asText(guarantor.LocationAspireRecordId),
        _a);
};
var buildGuarantorLookupValues = function (matched) {
    var _a;
    var _b, _c;
    var guarantor = (_b = matched.GuarantorInfo) !== null && _b !== void 0 ? _b : {};
    var _d = resolveCountryAndState(guarantor.State), countryCode = _d.countryCode, stateCode = _d.stateCode;
    return __assign((_a = {}, _a[GUARANTOR_FIELD.BusinessName] = asText((_c = guarantor.BusinessName) !== null && _c !== void 0 ? _c : guarantor.Name), _a[GUARANTOR_FIELD.BusinessEntityType] = resolveEntityTypeCode(guarantor.CompanyDesc), _a[GUARANTOR_FIELD.OwnershipPercentage] = readPercentOwnership(guarantor), _a[GUARANTOR_FIELD.BusinessFedTaxId] = formatTaxIdForDisplay(guarantor.SSN), _a), buildSharedGuarantorValues(guarantor, countryCode, stateCode));
};
var buildIndividualGuarantorLookupValues = function (matched) {
    var _a, _b, _c;
    var _d, _e;
    var guarantor = (_d = matched.GuarantorInfo) !== null && _d !== void 0 ? _d : {};
    var _f = resolveCountryAndState(guarantor.State), countryCode = _f.countryCode, stateCode = _f.stateCode;
    var percentOwnership = readPercentOwnership(guarantor);
    var rawTaxId = toRawTaxId(guarantor.SSN);
    return __assign(__assign(__assign((_a = {}, _a[GUARANTOR_FIELD.FirstName] = asText(guarantor.FirstName), _a[GUARANTOR_FIELD.MiddleName] = asText(guarantor.MiddleName), _a[GUARANTOR_FIELD.LastName] = asText(guarantor.LastName), _a[GUARANTOR_FIELD.Suffix] = asText(guarantor.Suffix), _a[GUARANTOR_FIELD.TaxpayerId] = rawTaxId
        ? countryCode === CANADA_COUNTRY_CODE
            ? formatSINInput(rawTaxId)
            : formatSSNInput(rawTaxId)
        : '', _a[GUARANTOR_FIELD.DateOfBirth] = toFormDate((_e = guarantor.DOB) !== null && _e !== void 0 ? _e : guarantor.DateOfBirth), _a), (percentOwnership ? (_b = {}, _b[GUARANTOR_FIELD.HasOwnership] = 1, _b) : {})), (_c = {}, _c[GUARANTOR_FIELD.OwnershipPercentage] = percentOwnership, _c[GUARANTOR_FIELD.BusinessTitle] = asText(guarantor.BusinessTitle), _c)), buildSharedGuarantorValues(guarantor, countryCode, stateCode));
};
var signerGuarantorAddressField = function (suffix) {
    return buildAddressFieldName(GUARANTOR_ADDRESS_PREFIX, suffix);
};
var buildSignerGuarantorLookupValues = function (matched) {
    var _a;
    var _b, _c, _d;
    var guarantor = (_b = matched.GuarantorInfo) !== null && _b !== void 0 ? _b : {};
    console.log("282..", guarantor);
    var _e = resolveCountryAndState(guarantor.State), countryCode = _e.countryCode, stateCode = _e.stateCode;
    return _a = {},
        _a[CUSTOMER_FIELD.PercentOwnership] = readPercentOwnership(guarantor),
        _a[CUSTOMER_FIELD.BusinessTitle] = asText(guarantor.BusinessTitle),
        _a[CUSTOMER_FIELD.DateOfBirth] = toFormDate((_c = guarantor.DOB) !== null && _c !== void 0 ? _c : guarantor.DateOfBirth),
        _a[signerGuarantorAddressField('Address')] = asText(guarantor.Address),
        _a[signerGuarantorAddressField('Country')] = countryCode,
        _a[signerGuarantorAddressField('City')] = asText(guarantor.City),
        _a[signerGuarantorAddressField('State')] = stateCode,
        _a[signerGuarantorAddressField('PostalCode')] = asText(guarantor.PostalCode),
        _a[GUARANTOR_ASPIRE_FIELD.GuarantorAspireOId] = asText(guarantor.GuarantorAspireOId),
        _a[GUARANTOR_ASPIRE_FIELD.GuarantorAspireRecordId] = asText(guarantor.GuarantorAspireRecordId),
        _a[GUARANTOR_ASPIRE_FIELD.LocationAspireOId] = asText(guarantor.LocationAspireOId),
        _a[GUARANTOR_ASPIRE_FIELD.LocationAspireRecordId] = asText(guarantor.LocationAspireRecordId),
        _a[GUARANTOR_ASPIRE_FIELD.SignerContactAspireOId] = Array.isArray(matched.Contacts)
            ? asText((_d = matched.Contacts[0]) === null || _d === void 0 ? void 0 : _d.ContactAspireOId)
            : '',
        _a[SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD.FirstName] = asText(guarantor.FirstName),
        _a[SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD.LastName] = asText(guarantor.LastName),
        _a[SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD.Email] = asText(guarantor.Email),
        _a[SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD.PhoneNumber] = asText(guarantor.PhoneNumber),
        _a;
};
export var signerGuarantorTaxIdLookup = function (taxId) { return __awaiter(void 0, void 0, void 0, function () {
    var matched;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetchGuarantorByTaxId(taxId, GUARANTOR_TYPE.Individual)];
            case 1:
                matched = _a.sent();
                return [2, matched ? buildSignerGuarantorLookupValues(matched) : null];
        }
    });
}); };
export var createGuarantorTaxIdLookup = function (beginContactsReport, confirmMatch) { return function (taxId, formValues) { return __awaiter(void 0, void 0, void 0, function () {
    var guarantorType, onContacts, matched, values, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                guarantorType = String((_b = formValues[GUARANTOR_FIELD.GuarantorType]) !== null && _b !== void 0 ? _b : GUARANTOR_TYPE.Individual);
                onContacts = beginContactsReport === null || beginContactsReport === void 0 ? void 0 : beginContactsReport();
                return [4, fetchGuarantorByTaxId(taxId, guarantorType)];
            case 1:
                matched = _d.sent();
                if (!matched) {
                    onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                    return [2, null];
                }
                values = guarantorType === GUARANTOR_TYPE.Business
                    ? buildGuarantorLookupValues(matched)
                    : buildIndividualGuarantorLookupValues(matched);
                _a = confirmMatch;
                if (!_a) return [3, 3];
                return [4, confirmMatch(values)];
            case 2:
                _a = !(_d.sent());
                _d.label = 3;
            case 3:
                if (_a) {
                    onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                    return [2, null];
                }
                if (guarantorType !== GUARANTOR_TYPE.Business) {
                    onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                    return [2, values];
                }
                onContacts === null || onContacts === void 0 ? void 0 : onContacts(toContactOptions(matched.Contacts, String((_c = values[GUARANTOR_FIELD.BusinessEntityType]) !== null && _c !== void 0 ? _c : '')));
                return [2, values];
        }
    });
}); }; };
